// Helpers e estilos compartilhados pelos sub-componentes de Composições.
// Extraído de ComercialComposicoes.tsx durante refactor topológico.

import { fetchAuthSession } from 'aws-amplify/auth';
import { fmtDataBr as _fmtDataBr } from '../../utils/dataFmt';

export async function getToken(): Promise<string> {
  const session = await fetchAuthSession();
  return session.tokens?.idToken?.toString() ?? '';
}

export const fmt = (v: number) =>
  'R$ ' + (v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtDate = _fmtDataBr;

export const th: React.CSSProperties = {
  padding: '6px 8px', textAlign: 'left', fontSize: 11, fontWeight: 600, letterSpacing: '0.04em',
};
export const td: React.CSSProperties = { padding: '3px 8px', fontSize: 12 };
// Sprint UI: padding mínimo nos itens do grupo da composição —
// prioridade é ver o máximo de linhas possível sem scroll.
export const tdEdit: React.CSSProperties = { padding: '1px 4px' };
export const btnMini: React.CSSProperties = {
  fontSize: 11, padding: '2px 6px', borderRadius: 3, border: '0.5px solid #ddd',
  background: '#fff', cursor: 'pointer', marginRight: 2, color: '#6A7092',
};
export const modalOverlay: React.CSSProperties = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
};
export const modalContent: React.CSSProperties = {
  background: '#fff', borderRadius: 12, padding: 24, width: '92%', maxHeight: '92vh', overflow: 'auto',
};
export const labelStyle: React.CSSProperties = {
  fontSize: 11, fontWeight: 600, color: '#555', marginBottom: 4, display: 'block',
};
export const inputStyle: React.CSSProperties = {
  width: '100%', padding: '7px 10px', fontSize: 13, borderRadius: 5,
  border: '0.5px solid #ddd', boxSizing: 'border-box',
};
export const inputStyleSm: React.CSSProperties = {
  width: '100%', padding: '2px 5px', fontSize: 11, borderRadius: 3,
  border: '0.5px solid #ddd', boxSizing: 'border-box', lineHeight: 1.3,
};
